import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-new-form',
  templateUrl: './turns-new-form.component.html',
  styleUrls: ['./turns-new-form.component.scss']
})
export class TurnsNewFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
